import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import "./EditGovApprovedCouncil.css";

const EditGovApprovedCouncil = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [title, setTitle] = useState("");
  const [icon, setIcon] = useState(null);
  const [link, setLink] = useState("");

  // Fetch existing data on mount
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/councils/${id}`)
      .then((response) => {
        const { title, iconUrl, link } = response.data;
        setTitle(title);
        setLink(link);
        setIcon(iconUrl); // This can be a preview link, or reset if uploading a new file.
      })
      .catch((error) => {
        console.error("Error fetching council data:", error);
      });
  }, [API_BASE_URL, id]);

  // Update title and icon state on change
  const handleTitleChange = (e) => setTitle(e.target.value);
  const handleIconChange = (e) => setIcon(e.target.files[0]);
  const handleLinkChange = (e) => setLink(e.target.value);

  // Handle form submission to update council data
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("link", link);
    if (icon instanceof File) {
      formData.append("councilIcon", icon);
    }

    try {
      await axios.put(`${API_BASE_URL}/admin/councils/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Council updated successfully!");
      navigate("/all-government-approved-council");
    } catch (error) {
      alert("Failed to update council. Please try again.");
      console.error("Error updating council data:", error);
    }
  };

  return (
    <div id="edit-gov-approved-council-main">
      <div className="edit-gov-approved-council-head-nav-btns">
        <h4>Edit Government Approved Council</h4>
        <div className="header-main-btns">
          <button onClick={() => navigate("/government-approved-council")}>
            Gov Approved Council
          </button>
          <button onClick={() => navigate("/all-government-approved-council")}>
            All Gov Approved Council
          </button>
        </div>
      </div>
      <div className="edit-gov-approved-council-inner ">
        <form onSubmit={handleSubmit}>
          <div className="edit-gov-app-input">
            <label>
              <b>Title</b>
            </label>
            <input
              type="text"
              placeholder="Enter Title"
              className="edit-gov-appr-concl-field"
              value={title}
              onChange={handleTitleChange}
              required
            />
          </div>
          <div className="edit-gov-app-input">
            <label>
              <b>Link</b>
            </label>
            <input
              type="text"
              name="officialLink"
              value={link}
              onChange={handleLinkChange}
              placeholder="Enter Link"
              className="edit-gov-appr-concl-field"
            />
          </div>
          <div className="edit-gov-app-input">
            <label>
              <b>Upload Icon</b>
            </label>
            <input
              type="file"
              className="edit-gov-appr-concl-field"
              onChange={handleIconChange}
            />
          </div>
          <div className="new-chapter-form-buttons">
            <button type="submit" className="new-chapter-submit-btn">
              Save
            </button>
            <button
              type="button"
              className="new-chapter-cancel-btn"
              onClick={() => navigate("/government-approved-council")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditGovApprovedCouncil;
